<soft-page>
  <soft-page-header>
    <div class="flex flex-col-reverse w-full">
      <soft-step-header [steps]="steps" [currentIndex]="1" #stepper></soft-step-header>
      @if (lieferant$ | async; as lieferant) {
        <soft-default-header [overline]="stepper.stepText"
                             class="px-0! pt-0! mt-0!"
                             [title]="$safeNavigationMigration(stepper.current()?.header)"
                             [subtitle]="$safeNavigationMigration(stepper.current()?.subHeader) + lieferant.kurzbez">
        </soft-default-header>
      }
    </div>
  </soft-page-header>

  <soft-page-panel panelStyle="plain" class="overflow-y-auto">
    <soft-page-panel-header>
      <div class="flex flex-row mb-1 w-full">
        <soft-filter-and-sort
          #filterAndSortComponent
          class="w-full"
          [filterConfig]="filterConfig"
          [sortConfig]="sortConfig"
          [explorer]="explorerBestellungen">
        </soft-filter-and-sort>
      </div>
    </soft-page-panel-header>

    <div [softScrollIntoView]="true" scrollBehavior="instant"></div>

    @if ((loading$ | async) === false) {
      @if (explorerBestellungen.result(); as bestellungen) {
        <div class="w-full">
          <div class="flex flex-col w-full">
            <soft-accordion class="flex flex-col gap-2 w-full select-none" [multi]="true">
              @for (bestellung of bestellungen; track bestellung; let bestellungLast = $last) {
                <soft-accordion-item
                  #bestellungAccordionItem
                >
                  <div
                    class="bg-surface flex flex-row gap-4 w-full border-b border-b-solid items-center justify-between cursor-pointer !p-3"
                    [ngClass]="{
                'rounded-sm! border-b-transparent': !bestellungAccordionItem.expanded,
                'rounded-t-sm! border-b-border': bestellungAccordionItem.expanded,
              }"
                    [style.border-bottom-left-radius]="bestellungAccordionItem.expanded ? '0px' : ''"
                    [style.border-bottom-right-radius]="bestellungAccordionItem.expanded ? '0px' : ''"
                    *softAccordionItemHeader
                  >
                    <div class="flex items-center justify-center h-full">
                      <soft-checkbox
                        [class]="'flex flex-col w-auto'"
                        [checked]="bestellung.id | in: selectedBestellungen()"
                        (valueChange)="selectOrUnselectBestellung(bestellung)"
                        (click)="$event.stopPropagation()"
                      >
                      </soft-checkbox>
                    </div>

                    <div class="flex flex-row w-full">
                      <div
                        class="flex flex-col w-4/5 gap-1"
                        (click)="selectOrUnselectBestellung(bestellung)"
                      >
                        <div class="flex flex-row gap-1 w-full justify-items-start items-center text-light">
                          <div class="flex text-sm text-light">
                            @if ($safeNavigationMigration(bestellung?.bestelldatum) | isDefinedNotEmpty) {
                              <span>
                                {{ $safeNavigationMigration(bestellung?.bestelldatum) | format:'DATE.DEFAULT' }}
                              </span>
                            }
                          </div>

                          <strong>&bull;</strong>

                          <div class="text-sm">
                            {{ bestellung.bewegungen.length }}
                            {{
                              bestellung.bewegungen.length === 1
                                ? ('#WWS_WARENUEBERNAHME.BESTELLUNG.LABEL_ENTHALTENE_BEWEGUNG'
                                  | translate)
                                : ('#WWS_WARENUEBERNAHME.BESTELLUNG.LABEL_ENTHALTENE_BEWEGUNGEN'
                                  | translate)
                            }}
                          </div>
                        </div>
                        <div class="flex flex-row w-full justify-items-start">
                          <div class="flex font-semibold">
                            @if (bestellung.bestellnummer) {
                              <span>
                            {{
                                  '#WWS_WARENUEBERNAHME.BESTELLUNG.LABEL_BESTELLNUMMER'
                                    | translate
                                }}
                                {{ bestellung.bestellnummer }}
                          </span>
                            }
                          </div>
                        </div>

                        @if (($safeNavigationMigration(bestellung?.abholdatum) | isDefinedNotEmpty) || ($safeNavigationMigration(bestellung?.lieferdatum) | isDefinedNotEmpty)) {
                          <div class="flex items-center gap-1">
                            <soft-icon name="fa-regular fa-clock text-light"></soft-icon>
                            <span class="text-sm text-light">
                               {{ (bestellung?.abholdatum || bestellung?.lieferdatum | format: 'DATE.DEFAULT') + ((!!bestellung?.lieferdatumBis && bestellung?.lieferdatumBis !== bestellung?.lieferdatum) ? (' - ' + ($safeNavigationMigration(bestellung?.lieferdatumBis) | format: 'DATE.DEFAULT')) : '') + (!!bestellung?.lieferzeit ? (' ' + bestellung.lieferzeit) : '') }}
                              </span>
                          </div>
                        }
                      </div>
                      <div class="flex flex-col w-1/5 items-end self-center mr-2">
                        <div class="flex flex-col w-auto">
                          <button
                            class="soft-button primary h-10 rounded-sm"
                            [disabled]="bestellung.bewegungen.length <= 0"
                            (click)="bestellungAccordionItem.toggle()"
                          >
                            @if (bestellungAccordionItem.expanded) {
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M4.5 15.75l7.5-7.5 7.5 7.5"
                                />
                              </svg>
                            }
                            @if (!bestellungAccordionItem.expanded) {
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                                />
                              </svg>
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    *softAccordionItemContent="bestellungAccordionItem.expanded"
                    (click)="selectOrUnselectBestellung(bestellung)"
                    class="bg-surface-tertiary w-full rounded-b-sm pt-2 pb-2 flex flex-col gap-2"
                  >
                    @for (bewegung of bestellung.bewegungen; track bewegung; let last = $last) {
                      <div
                        class="bg-surface rounded-sm mx-2 flex flex-col gap-1 p-2"
                        [ngClass]="{
                  'rounded-b-sm': last,
                  '!border-b': !last
                }">
                        <div class="text-sm text-light">
                          @if ((bewegung?.lfdnr?.toString()?.length ?? 0) === 1) {
                            <span
                            >00{{ bewegung?.lfdnr }}</span
                            >
                          }
                          @if ((bewegung?.lfdnr?.toString()?.length ?? 0) === 2) {
                            <span
                            >0{{ bewegung?.lfdnr }}</span
                            >
                          }
                          @if ((bewegung?.lfdnr?.toString()?.length ?? 0) >= 3) {
                            <span>{{
                                bewegung?.lfdnr
                              }}</span>
                          }
                        </div>
                        <div class="flex flex-row justify-between w-full">
                          <div class="flex flex-col">
                            <div class="flex text-base font-semibold">
                              {{ bewegung?.artikelMenge?.artikel?.artbez1 ?? '' }}
                            </div>
                            @if ($safeNavigationMigration(bewegung?.artikelMenge?.artikel?.artbez2) | isDefinedNotEmpty) {
                              <span class="text-sm text-light">{{
                                  bewegung?.artikelMenge?.artikel?.artbez2
                                }}</span>
                            }
                            @if ($safeNavigationMigration(bewegung?.artikelMenge?.artikel?.artbez3) | isDefinedNotEmpty) {
                              <span class="text-sm text-light">{{
                                  bewegung?.artikelMenge?.artikel?.artbez3
                                }}</span>
                            }
                            @if ($safeNavigationMigration(bewegung?.artikelMenge?.artikel?.artbez4) | isDefinedNotEmpty) {
                              <span class="text-sm text-light">{{
                                  bewegung?.artikelMenge?.artikel?.artbez4
                                }}</span>
                            }
                            @if ($safeNavigationMigration(bewegung?.artikelMenge?.artikel?.artbez5) | isDefinedNotEmpty) {
                              <span class="text-sm text-light">{{
                                  bewegung?.artikelMenge?.artikel?.artbez5
                                }}</span>
                            }
                          </div>
                          <div class="flex">
                            {{ $safeNavigationMigration(bewegung?.artikelMenge?.menge) | number: '1.0-9' }}
                            {{ bewegung?.artikelMenge?.einheit?.arteh ?? '' | uppercase }}
                          </div>
                        </div>
                        <div class="text-sm">
                          {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_ARTIKELNUMMER' | translate }}
                          {{ bewegung.artikelMenge?.artikel?.nummer ?? '' }}
                        </div>
                        @if (bewegung?.dimension && bewegung?.dimension?.massUnitId) {
                          <div>
                            <span class="italic font-semibold text-xs mt-1">{{
                                bewegung?.dimension?.massUnitId
                              }}</span>
                          </div>
                        }
                        @if (bewegung?.zeilentext && bewegung?.zeilentext !== '') {
                          <div
                            class="text-sm text-light border-t w-full pt-2 mt-1"
                          >
                            {{ bewegung?.zeilentext }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                </soft-accordion-item>
              }
            </soft-accordion>
          </div>
        </div>
      }
    } @else {
      <div class="flex flex-col w-full">
        <div
          class="flex flex-row mt-3 gap-4 items-center h-[91px] w-full soft-card !p-3 rounded-sm"
          *softRepeat="10"
        >
          <div class="flex flex-col h-full justify-center w-auto">
            <div class="skeleton rounded w-[56px] h-[40px]"></div>
          </div>
          <div class="flex flex-col justify-between h-full w-full">
            <div class="skeleton rounded h-4 w-20"></div>
            <div class="skeleton rounded h-4 w-28"></div>
            <div class="skeleton rounded h-4 w-20"></div>
          </div>
        </div>
      </div>
    }
  </soft-page-panel>
</soft-page>

